// In-app pub/sub used by both deck-side plugin and speaker app.
// Lets multiple modules subscribe to a single MQTT message stream
// without each opening its own connection.

export class EventBus {
  constructor() { this.handlers = new Map(); }

  on(type, fn) {
    let set = this.handlers.get(type);
    if (!set) { set = new Set(); this.handlers.set(type, set); }
    set.add(fn);
    return () => set.delete(fn);
  }

  emit(type, payload) {
    // Fire exact-match handlers first.
    const exact = this.handlers.get(type);
    if (exact) for (const fn of exact) try { fn(payload, type); } catch (e) { console.error('[bus]', type, e); }
    // Then prefix-wildcard handlers (e.g. 'slide.*' or '*').
    for (const [pattern, set] of this.handlers) {
      if (pattern === '*' || (pattern.endsWith('.*') && type.startsWith(pattern.slice(0, -1)))) {
        for (const fn of set) try { fn(payload, type); } catch (e) { console.error('[bus]', type, e); }
      }
    }
  }
}
